import React,{useState,useEffect} from "react";
import './ArtistRooster.css'
import artistrooster1 from './../../../images/artistrooster1.png'
import artistrooster2 from './../../../images/artistrooster2.png'
import artistrooster3 from './../../../images/artistrooster3.png'
import artistrooster4 from './../../../images/artistrooster4.png'
import artistrooster5 from './../../../images/artistrooster5.png' 
import artistroosterdown from './../../../images/artistroosterdown.png'
import artistroosterup from './../../../images/artistroosterup.png'
import artistroostersamepos from './../../../images/artistroostersamepos.png'


function ArtistRooster({nav}) {

    useEffect(()=>{
      
        nav("ArtistRoster")
        
    },[])

    return (
        <div className="HomeContainer"  style={{height:'100vh',overflowY:'scroll',paddingBottom:'10em',paddingLeft:'2.5em'}}>
         
          
                <div className="MusicHeaderMain">ARTIST ROSTER</div>
             
                <div className="ArtistRoosterPageContainer">
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">1.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'1.1em',marginRight:'0.75em'}}>
                                    <img src={artistroosterup} />
                                </div>
                                <img src={artistrooster1} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Peggy Gou</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">2.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.89em',marginRight:'0.65em',marginTop:'0.2em'}}>
                                    <img src={artistroostersamepos}/>
                                </div>
                                <img src={artistrooster2} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Arisa Suzuki</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">3.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.55em',marginTop:'0.2em'}}>
                                    <img src={artistroosterdown} />
                                </div>
                                <img src={artistrooster3} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Jay Park</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">4.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.75em'}}>
                                    <img src={artistroosterup} />
                                </div>
                                <img src={artistrooster4} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Sabrina Carpenter</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">5.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.55em',marginTop:'0.2em'}}>
                                    <img src={artistroosterdown} />
                                </div>
                                <img src={artistrooster5} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Billie Eilish</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">6.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.75em'}}>
                                    <img src={artistroosterup} />
                                </div>
                                <img src={artistrooster1} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Peggy Gou</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">7.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.89em ',marginRight:'0.65em',marginTop:'0.2em'}}>
                                    <img src={artistroostersamepos}/>
                                </div>
                                <img src={artistrooster2} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Arisa Suzuki</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">8.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.55em',marginTop:'0.2em'}}>
                                    <img src={artistroosterdown} />
                                </div>
                                <img src={artistrooster3} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Jay Park</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">9.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.75em'}}>
                                    <img src={artistroosterup} />
                                </div>
                                <img src={artistrooster4} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Sabrina Carpenter</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.5em'}}>
                                <div className="HomeH5">10.</div>
                                <div style={{maxHeight:'1.25em',maxWidth:'1.25em',marginLeft:'0.9em',marginRight:'0.55em',marginTop:'0.2em'}}>
                                    <img src={artistroosterdown} />
                                </div>
                                <img src={artistrooster5} style={{maxHeight:'2.5em',maxWidth:'2.5em',marginRight:'0.75em'}}/>
                                <div className="HomeH4">Billie Eilish</div>
                            </div>
                </div>
            
            
            
        </div>
        
    );
}

export default ArtistRooster;